import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";

const Shell = ({ children }) => (
  <div className="min-h-screen flex flex-col items-center justify-center px-4 py-16 bg-[#F9F7F3]">
    <Link to="/" data-testid="auth-back-home-link" className="font-display text-2xl mb-8 text-[#1E231F]">
      Chiara Piccioni
    </Link>
    {children}
  </div>
);

export const SignInPage = () => (
  <Shell>
    <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
  </Shell>
);

export const SignUpPage = () => (
  <Shell>
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </Shell>
);
